var config = {
    leftNav: ["List","Detail","Preview",'chooseSeat','wh5'],//拥有左侧导航页面的路由name
    topNav: ["Home","Question","Risk","List","Detail","Preview",'chooseSeat'],//拥有顶部导航页面的路由name
    productToDoc: {
        76: '7e',
        123: '7cjg',
        1: '8c',
        122: '8e',
        83: '9e',
        84: '9b',
        124: '9c',
        80: 'mytrader',
        39: 'yun',
        78: 'yun',
        79: 'yun',
        46: 'mai',
        107: 'mai',
        44: 'model',
        18: 'keyboard',
        27: 'other',
        81: 'marketData',
        127: 'taili',
        132: 'taili_2024',
        110: '10c',
        125: '10e',
        111: '10b',
        126: '5e',
        129: '5e',
        128: '5c',
        130: '11c',
        131: '11e',
        136: 'course'
    },
    hasPay: [76,123,1,83,84,80,8,9,110,125,111,122,124,126,128,129,130, 131],
    hasYun: id =>{
        return [39,78,79].indexOf(id) >= 0
    }
}
export default config